<template>
    <div>
        <div v-for="(item,index) in category" :key="index">
            <van-cell :title="item" is-link @click="toContent(index)"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wp_jd_article",
        props: {
            cid: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                list: this.$article_config.helpList,
                category: [],
            }
        },
        created() {
            let _cid = this.$common.getUrlKey("cid");
            if (_cid) {
                this.cid = _cid;
            }

            if (this.cid === 'course') {
                this.list = this.$article_config.guideList;
            }
            if (this.cid === 'rule') {
                this.list = this.$article_config.ruleList;
            }
            this.$log(this.cid);
            this.loadCategory();
        },
        methods: {
            loadCategory() {
                for (let i = 0; i < this.list.length; i++) {
                    let path = this.list[i];
                    let title = path.substring(path.lastIndexOf("/") + 1, path.length).replace('.md', '')
                    this.category.push(title)
                }
            },
            toContent(aid) {
                let _url = '/article/content?aid=' + aid;
                if (this.cid) {
                    _url = _url + "&cid=" + this.cid
                }
                // _url = _url + "&_time=" + new Date().getTime();
                this.$router.push(_url)
            }
        }
    }
</script>

<style scoped>

</style>